module.exports = {"TXTCLI_Street_Address":{"id":"TXTCLI_Street_Address","defaultMessage":"Straße","flags":["TRACK"],"track":"Street Address"}}